import React from 'react';
import { Divider } from 'semantic-ui-react';
import Payment from '../components/Payment';

export default function PaymentPage() {

  return (
    <React.Fragment>
      <Payment />
      <Divider hidden/>
    </React.Fragment>
  );
}